'use client';

import React from 'react';

import { TasticProps } from 'frontastic/tastics/types';
import {CmsMaterContainerProps, } from 'components/commercetools-ui/organisms/content/cms-master-container';
import CmsMaterContainer from 'components/commercetools-ui/organisms/content/cms-master-container';

const CmsMaterContainerTastic  = ({ data, categories }: TasticProps<CmsMaterContainerProps>) => {
  return <CmsMaterContainer data={data?.data?.dataSource} />;
};

export default CmsMaterContainerTastic;